import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';
import LoaderOverlay from 'src/components/Loader';

interface SubdomainProtectedRouteProps {
  children: React.ReactNode;
  includedSubdomains?: AppSubdomains[];
  excludedSubdomains?: AppSubdomains[];
}

function SubdomainProtectedRoute({
  children,
  includedSubdomains,
  excludedSubdomains,
}: SubdomainProtectedRouteProps) {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    const currentSubdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);

    if (includedSubdomains && includedSubdomains.length > 0) {
      if (!includedSubdomains.includes(currentSubdomain)) {
        setIsAuthorized(false);
        navigate('/unauthorized', { replace: true });
        return;
      }
    }

    if (excludedSubdomains && excludedSubdomains.length > 0) {
      if (excludedSubdomains.includes(currentSubdomain)) {
        setIsAuthorized(false);
        navigate('/unauthorized', { replace: true });
        return;
      }
    }

    setIsAuthorized(true);
  }, [navigate, includedSubdomains, excludedSubdomains]);

  if (isAuthorized === null) {
    return <LoaderOverlay />;
  }

  return isAuthorized ? children : null;
}

export default SubdomainProtectedRoute;
